export default __webpack_public_path__ + "static/media/clo_login.5693bcb7.jpg";